import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
@Injectable()
export class AuthGuard  {

    constructor(private router: Router, private authenticationService:AuthenticationService) { }

    canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (sessionStorage.getItem('vvuser')) {
           //let currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
           if(state.url && state.url.startsWith("/edit/pdf-forms") && this.authenticationService.isFormsEditorEnabled(this.authenticationService.getClientName()))
                return true;
            else if(state.url.startsWith("/edit/pdf-forms"))
                this.router.navigate(['/dashboard']);
            else
                return true;
        }
        // not logged in so redirect to home page for logging in
        this.router.navigate(['/auth/login']);
        return  ;
    }
    
}